import React from "react";
import {
  Box,
  TextField,
  Typography,
  Switch,
  FormControlLabel,
  Button,
} from "@mui/material";
import { FieldArray, useFormikContext } from "formik";
import { fieldConfig } from "../config/fieldConfig";

const AvailabilitySection = () => {
  const { values, handleChange, errors, touched } = useFormikContext();

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography variant="h6" gutterBottom>
        Availability
      </Typography>

      <Typography variant="body2" color="textSecondary" gutterBottom>
        Define the available dates for your tour all year round, as well as the
        minimum and maximum group sizes. You can also mark whether the tour is
        currently available for booking.
      </Typography>

      <FieldArray name="availability">
        {({ push, remove }) => (
          <>
            {values.availability.map((item, index) => (
              <Box
                gap={2}
                p={2}
                key={index}
                border={1}
                borderColor="grey.300"
                borderRadius={2}
                display="flex"
                flexDirection="column"
                sx={{ borderBottom: "1px solid #ddd", mb: 2, pb: 2 }}
              >
                <TextField
                  fullWidth
                  label={fieldConfig.availability.startDate.label}
                  placeholder={fieldConfig.availability.startDate.placeholder}
                  type="date"
                  name={`availability[${index}].startDate`}
                  value={item.startDate}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                  error={touched?.availability?.[index]?.startDate && Boolean(errors?.availability?.[index]?.startDate)}
                  helperText={
                    touched?.availability?.[index]?.startDate && errors?.availability?.[index]?.startDate
                      ? errors.availability[index].startDate
                      : fieldConfig.availability.startDate.helperText
                  }
                />

                <TextField
                  fullWidth
                  label={fieldConfig.availability.endDate.label}
                  placeholder={fieldConfig.availability.endDate.placeholder}
                  type="date"
                  name={`availability[${index}].endDate`}
                  value={item.endDate}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                  error={touched?.availability?.[index]?.endDate && Boolean(errors?.availability?.[index]?.endDate)}
                  helperText={
                    touched?.availability?.[index]?.endDate && errors?.availability?.[index]?.endDate
                      ? errors.availability[index].endDate
                      : fieldConfig.availability.endDate.helperText
                  }
                />

                <TextField
                  fullWidth
                  label={fieldConfig.availability.minGuests.label}
                  placeholder={fieldConfig.availability.minGuests.placeholder}
                  type="number"
                  name={`availability[${index}].minGuests`}
                  value={item.minGuests}
                  onChange={handleChange}
                  error={touched?.availability?.[index]?.minGuests && Boolean(errors?.availability?.[index]?.minGuests)}
                  helperText={
                    touched?.availability?.[index]?.minGuests && errors?.availability?.[index]?.minGuests
                      ? errors.availability[index].minGuests
                      : fieldConfig.availability.minGuests.helperText
                  }
                />

                <TextField
                  fullWidth
                  label={fieldConfig.availability.maxGuests.label}
                  placeholder={fieldConfig.availability.maxGuests.placeholder}
                  type="number"
                  name={`availability[${index}].maxGuests`}
                  value={item.maxGuests}
                  onChange={handleChange}
                  helperText={fieldConfig.availability.maxGuests.helperText}
                />

                <FormControlLabel
                  control={
                    <Switch
                      name={`availability[${index}].isAvailable`}
                      checked={item.isAvailable}
                      onChange={handleChange}
                    />
                  }
                  label={fieldConfig.availability.isAvailable.label}
                  helperText={fieldConfig.availability.isAvailable.helperText}
                />
                <Box>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={() => remove(index)}
                  >
                    Remove Availability
                  </Button>
                </Box>
              </Box>
            ))}

            <Button
              variant="outlined"
              color="primary"
              onClick={() =>
                push({
                  startDate: "",
                  endDate: "",
                  minGuests: "",
                  maxGuests: "",
                  isAvailable: true,
                })
              }
              sx={{ mt: 2 }}
            >
              Add Availability
            </Button>
          </>
        )}
      </FieldArray>
    </Box>
  );
};

export default AvailabilitySection;
